import React, { memo } from 'react';
import { ICON_PATHS } from '../utils/iconSvgPaths';

const LegendIcon = ({ iconType, color, size = 18 }) => {
  const entry = ICON_PATHS[iconType];
  if (!entry) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox={entry.viewBox}
      style={{ flexShrink: 0, display: 'block' }}
    >
      {entry.d.map((d, i) => (
        <path key={i} d={d} fill={color} />
      ))}
    </svg>
  );
};

const LabelLegend = memo(({ categories, style }) => {
  if (!categories || !categories.length) return null;
  return (
    <div className="leg-legend" style={style}>
      {categories.map((cat) => (
        <div key={cat.iconType} className="leg-legend-item">
          <LegendIcon iconType={cat.iconType} color={cat.color} size={11} />
          <span className="leg-legend-name" style={{ color: cat.color }}>
            {cat.name}
          </span>
        </div>
      ))}
    </div>
  );
});

export default LabelLegend;
